import { SET_TABLE_STATE, RESET_TABLE_STATE } from '../redux/types/types';

const initialState = {
    users: {
        searchInput: '',
        pageIndex: 0,
        sortBy: [{ id: "update_time", desc: true }],
        showDeleted: false
    },
    audiobooks: {
        searchInput: '',
        pageIndex: 0,
        sortBy: [{ id: "created_at", desc: true }],
        showDeleted: false
    },
    orders: {
        searchInput: '',
        pageIndex: 0,
        sortBy: [{ id: "created_at", desc: true }]
    }
};

const tableStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TABLE_STATE:
            return {
                ...state,
                [action.payload.tableName]: {
                    ...state[action.payload.tableName],
                    ...action.payload.stateData
                }
            };
        case RESET_TABLE_STATE:
            return {
                ...state,
                [action.payload.tableName]: initialState[action.payload.tableName]
            };
        default:
            return state;
    }
};

export default tableStateReducer;